import { utils } from "@photo-sphere-viewer/core";
export function intro(viewer, yaw = 0, pitch = 0) {
    viewer.navbar.hide();
    viewer.setOptions({
        mousemove: false,
        mousewheel: false,
    });
    return new utils.Animation({
        properties: {
            pitch: { start: -Math.PI / 2, end: Number(pitch) },
            yaw: { start: Math.PI / 2, end: Number(yaw) },
            zoom: { start: 0, end: 50 },
            maxFov: { start: 130, end: 90 },
            fisheye: { start: 2, end: 0 },
        },
        duration: 2500,
        easing: "inOutQuad",
        onTick: (properties) => {
            viewer.setOptions({
                fisheye: properties.fisheye,
                maxFov: properties.maxFov,
            });
            viewer.rotate({ yaw: properties.yaw, pitch: properties.pitch });
            viewer.zoom(properties.zoom);
        },
    }).then(() => {
        viewer.navbar.show();
        viewer.setOptions({
            mousemove: true,
            mousewheel: true,
        });
    });
}
